/**
 * Filter category keys used by URL state and Share of Voice.
 * @deprecated Prefer NewsFeedFilterCategory from news-feed when in news-feed context.
 */
export const FilterCategory = {
  CATEGORY: "CATEGORY",
  SOCIAL: "SOCIAL",
  PUBLICATION_TIER: "PUBLICATION_TIER",
  PROMINENCE: "PROMINENCE",
  SENTIMENT: "SENTIMENT",
} as const;

export type FilterCategoryType =
  (typeof FilterCategory)[keyof typeof FilterCategory];
